import { render, staticRenderFns } from "./dialogShouyinBl.vue?vue&type=template&id=b952b898&scoped=true&"
import script from "./dialogShouyinBl.vue?vue&type=script&lang=js&"
export * from "./dialogShouyinBl.vue?vue&type=script&lang=js&"
import style0 from "./dialogShouyinBl.vue?vue&type=style&index=0&id=b952b898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952b898",
  null
  
)

export default component.exports